module.exports = __webpack_public_path__ + "static/haus_4k-1a81b28f4b8879139b115d8705a0c015.webp";